import axios from "axios";
import { ToastEmitter } from "./assets/toast-emitter";

const axiosClient = axios.create({
	baseURL: `${process.env.REACT_APP_STAGING_BACKEND_URL}`,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
});

const skip = ["n-finite.io/v1/shipping/shipment"];

axiosClient.interceptors.response.use(
	function (response) {
		return response.data;
	},
	function (error) {
		if (!skip.includes(error.request.responseURL))
			ToastEmitter({
				msg:
					error.response && error.response.data
						? msgGenerator(error.response.data)
						: "",
				type: "error",
			});

		return Promise.reject(error);
	}
);

const msgGenerator = (data) => {
	console.log("Error====>", data);
	if (data.message) {
		if (typeof data.message === "string") return data.message;
		if (typeof data.message === "object")
			return data.message.reduce(
				(p, c, i) => (i === 0 ? p + c : p + ", " + c),
				""
			);
	}
	if (data.data && data.data.response) {
		return data.data.response.errors.reduce(
			(p, c, i) => (i === 0 ? p + c.message : p + ", " + c.message),
			""
		);
	}
	return "";
};

export { axiosClient };
